export const hostUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:5000/' : 'api/';
